var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.1,
    height: 30,
    viewBox: "0 0 8.1 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.1a4.012 4.012 0 0 1-4-4 4.05 4.05 0 1 1 8.1 0 4.1 4.1 0 0 1-4.1 4zM4 1a2.946 2.946 0 0 0-3 3 3 3 0 0 0 6 0 2.946 2.946 0 0 0-3-3zm0 29a4.1 4.1 0 0 1 0-8.2A4.1 4.1 0 1 1 4 30zm0-7.1a3 3 0 1 0 3 3 2.946 2.946 0 0 0-3-3zM4 19a4.034 4.034 0 0 1-4-4.1 3.949 3.949 0 0 1 4-4 4.1 4.1 0 0 1 4.1 4A4.185 4.185 0 0 1 4 19zm0-7a3 3 0 1 0 3 3 2.946 2.946 0 0 0-3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.555f2c19bff1e7e0e70fd9f4a2cfce40.svg";
export { ForwardRef as ReactComponent };